import ru from 'r3ui-lang-front/ru.json' with { type: 'json' };
import en from 'r3ui-lang-front/en.json' with { type: 'json' };
import es from 'r3ui-lang-front/es.json' with { type: 'json' };
import fr from 'r3ui-lang-front/fr.json' with { type: 'json' };
import pt from 'r3ui-lang-front/pt.json' with { type: 'json' };
import kk from 'r3ui-lang-front/kk.json' with { type: 'json' };
import vi from 'r3ui-lang-front/vi.json' with { type: 'json' };
import zh from 'r3ui-lang-front/zh.json' with { type: 'json' };
import uz from 'r3ui-lang-front/uz.json' with { type: 'json' };
import he from 'r3ui-lang-front/he.json' with { type: 'json' };
import { createI18n } from 'vue-i18n';
import type { I18nOptions } from 'vue-i18n';
import Cookies from 'js-cookie';

const messages: I18nOptions['messages'] = Object.assign({
  ru,
  en,
  es,
  fr,
  pt,
  kk,
  vi,
  zh,
  uz,
  he,
});

const savedLocale = Cookies.get('i18n_redirected') as string | undefined;
type Locale =
  'ru' | 'en' | 'es' | 'fr' | 'pt' | 'kk' | 'vi' | 'zh' | 'uz' | 'he';
const validLocale: Locale = (
  ['ru', 'en', 'es', 'fr', 'pt', 'kk', 'vi', 'zh', 'uz', 'he'].includes(
    savedLocale || ''
  )
    ? savedLocale
    : 'ru'
) as Locale;

const options: I18nOptions = {
  legacy: false,
  locale: validLocale,
  fallbackLocale: 'en',
  messages,
  missingWarn: false,
  fallbackWarn: false,
};
const i18n = createI18n({ ...options });

export const { t, locale, availableLocales } = i18n.global;
export const translate = (str: string) => {
  if (!str) return str;
  return t(str);
};

export default defineI18nConfig(() => {
  return {
    ...options,
    defaultLocale: 'ru',
    detectBrowserLanguage: {
      useCookie: true,
      cookieKey: 'i18n_redirected',
      redirectOn: 'root', // recommended
    },
  };
});
